var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackN(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99989 0C3.58876 0 0 3.5888 0 7.99999C0 12.4112 3.58876 16 7.99989 16C12.411 16 15.9998 12.4112 15.9998 7.99999C15.9998 3.5888 12.4111 0 7.99989 0Z",
    fill: "#FF5100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64531 9.8527C10.3413 9.75615 11.0531 9.91167 11.6498 10.2907L12.1135 9.5607C11.3439 9.07188 10.4252 8.87145 9.52639 8.9961C8.08142 9.19686 6.85417 10.2223 6.3999 11.6085L7.22179 11.8778C7.5739 10.8032 8.5252 10.0083 9.64531 9.8527Z",
    fill: "#413E34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32409 7.13512C5.80174 7.13512 6.18896 6.7479 6.18896 6.27024C6.18896 5.79258 5.80174 5.40536 5.32409 5.40536C4.84644 5.40536 4.45923 5.79258 4.45923 6.27024C4.45923 6.7479 4.84644 7.13512 5.32409 7.13512Z",
    fill: "#413E34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6754 7.13512C11.1531 7.13512 11.5403 6.7479 11.5403 6.27024C11.5403 5.79258 11.1531 5.40536 10.6754 5.40536C10.1978 5.40536 9.81055 5.79258 9.81055 6.27024C9.81055 6.7479 10.1978 7.13512 10.6754 7.13512Z",
    fill: "#413E34"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackN);
export default __webpack_public_path__ + "static/media/feedback-n.41c962fbb19e5ac87433c0e91f4115a1.svg";
export { ForwardRef as ReactComponent };